import { render, staticRenderFns } from "./ShareTwitterComponent.vue?vue&type=template&id=745dfef8&scoped=true&"
import script from "./ShareTwitterComponent.vue?vue&type=script&lang=js&"
export * from "./ShareTwitterComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745dfef8",
  null
  
)

export default component.exports